import { formatAsCurrency } from "../../utils";
import { SkeletonLoader } from "../SkeletonLoader";
import { IViewProps } from "./CurrencyDisplay";

export const View = (props: IViewProps) => {
  const {
    amountFontSize = 20,
    symbolFontSize = 14,
    title,
    showSkeleton,
  } = props;

  return (
    <span className="currency-display--container" title={title || ""}>
      <span
        className={`currency-symbol ${props.symbolClassName}`}
        style={{ fontSize: symbolFontSize }}
      >
        {props.currencyOrSymbol}
      </span>

      {showSkeleton ? (
        <SkeletonLoader type="placeholder" className="amount-placeholder" />
      ) : null}

      {showSkeleton ? null : (
        <span
          className={`currency-amount font-ctm--semibold ${props.amountClassName}`}
          style={{ fontSize: amountFontSize }}
        >
          {formatAsCurrency(props.amount)}
        </span>
      )}
    </span>
  );
};
